/**
 * The message a declined send carries, when there is one (GDN-3558).
 *
 * Gated on 409 specifically, and that gate is the point. Reading `data.message`
 * from any failure would put a 500's body in front of staff; worse, the generic
 * failure this replaces ends in advice — try from the record — that is actively
 * wrong for a conflict, because a 409 is the server's settled answer about this
 * patient and retrying anywhere cannot change it.
 *
 * ANY 409 is rendered, not only the two codes we know about today
 * (`no_open_requirements`, `no_online_step`). An allowlist would send a code
 * added later back to that same wrong advice, silently — and the bodies on this
 * route are staff-facing prose by contract. What is required is a usable
 * message: a 409 without one has told us nothing to show, so it falls through
 * to the generic failure rather than rendering a blank line.
 */
export const declinedMessage = (error: unknown): string | undefined => {
  if ((error as { status?: unknown } | null)?.status !== 409) return undefined;
  const message = (error as { data?: { message?: unknown } } | null)?.data?.message;
  return typeof message === 'string' && message.trim() !== '' ? message.trim() : undefined;
};
